<template>
  <div>
    <div :style="{ display: 'flex', alignItems: 'center' }">
      <v-divider :style="{ flex: 1 }" />
      <v-btn small icon outline color="grey" class="ma-0" @click="open = !open">
        <v-icon small>{{ open ? 'keyboard_arrow_up' : 'keyboard_arrow_down' }}</v-icon>
      </v-btn>
      <v-divider :style="{ flex: 1 }" />
    </div>
    <slot v-if="open" />
  </div>
</template>

<script>
export default {
  data() {
    return {
      open: false
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/view/billing/ToggleableContainer.vue